module.exports = __webpack_public_path__ + "img/insurance_percentage.a3651609.svg";